module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-main"
  }, [_c('div', {
    staticClass: "desktop-body"
  }, [_c('div', {
    staticClass: "desktop-title"
  }, [_vm._v("运 营 管 理 平 台")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3826e576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/desktop/desktop.vue
// module id = 1182
// module chunks = 2